import ValidationErrorList from "@components/ValidationErrorList"
import { isRejectedWithValue } from "@reduxjs/toolkit"
import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit"
import { enqueueSnackbar } from "notistack"
import { ReactNode } from "react"
import { HTTP_ERROR_STATUSES, HTTP_STATUS, isValidationErrorPayload } from "utils/http"

const SUPPRESS_ERRORS = [
  "checkScenarioSource",
  "postValidationFile",
  "postDashboardFile",
  "uploadScenarioSource",
  "getGraphScenarioFile",
  "getGraph",
]

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (
      HTTP_ERROR_STATUSES.includes(action?.payload?.status) &&
      !SUPPRESS_ERRORS.includes(action?.meta?.arg.endpointName)
    ) {
      handleErrorResponse(action)
    }
  }

  return next(action)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
const handleErrorResponse = async (action: any) => {
  const errorMessage = await getErrorMessage(action)

  enqueueSnackbar(errorMessage, { variant: "error" })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
const getErrorMessage = async (action: any): Promise<string | ReactNode> => {
  const status = action?.payload?.status
  const payload = action?.payload?.data
  if (status === HTTP_STATUS.INVALID_CONTENT && isValidationErrorPayload(payload)) {
    return <ValidationErrorList payload={payload} />
  } else if (status === HTTP_STATUS.FORBIDDEN && action.payload?.data instanceof Response) {
    const responseJSON = await action.payload.data.json()
    return responseJSON.message
  }

  return action?.payload?.data?.message || action?.payload?.data || "Server Error"
}
